import React from 'react'
import './bureaux.css'

import Bureaucontainer from '../../section/Bureaucontainer/Bureaucontainer'


const Bureau = () => {
 

  

    
  return (
    <>
    <Bureaucontainer/>
    


    <div className='container pagination'>

    

  </div>





    </>



    
  )
}

export default Bureau